<template lang="pug">
.image.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .container-image-s3
        img.image-preview-s3(v-if="!history" :src="getImagePath()" :alt="data.image")
        .data-information-list
          .data-title-list {{ replaceString(data.image, '/', ' / ') }}
          .data-title-list {{ replaceString(data.dir) }}
          .data-description-list.capitalize(v-if="!history") {{ size.width }}px *  {{ size.height }}px
          .data-description-list.capitalize(v-else :class="colorTransaction(data.transaction)") {{ data.transaction }}d
            span.lowercase  - {{ dateTime(data.createdAt) }}

  transition.user-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true" :path="getImagePath()" :size="size")

  transition.user-details-information(name="slide-fade")
    shHistory(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'ImageStatic',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false,
      image: {},
      size: {
        width: 0,
        height: 0
      }
    }
  },

  methods: {
    getImagePath () {
      const dir = this.data.dir.split('img/').join('')
      return `${this.imagePath}/${dir}`
    }
  },

  mounted () {
    this.image = new Image()
    this.image.src = this.getImagePath()

    setInterval(() => {
      this.size.width = this.image.width
      this.size.height = this.image.height
    }, 10)
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.image-preview-s3
  width 10em

.container-image-s3
  display flex
  flex-wrap wrap
  align-items center
  gap 1em
</style>



// WEBPACK FOOTER //
// src/components/pages/image/Image.vue